// This map is taken from https://git.build.ingka.ikea.com/payments/payment-notifier.
export const serviceIdToTransportMethodMap: { [key: string]: 'Truck' | 'Parcel' } = {
  '30000961': 'Truck',
  '50000955': 'Truck',
  '10000896': 'Truck',
  '00000948': 'Parcel',
  '40000606': 'Truck',
  '50000597': 'Parcel',
  '60000851': 'Truck',
  '40000852': 'Truck',
  '20000853': 'Truck',
  '00000854': 'Parcel',
  '70000855': 'Parcel',
  '50000856': 'Parcel',
  '90000897': 'Truck',
  '70000898': 'Truck',
  '50000899': 'Truck',
  '10000900': 'Parcel',
  '50990003': 'Truck',
  '10000919': 'Truck',
  '30000904': 'Truck',
  '50000903': 'Truck',
};
